import { MessageTag, ReplyVerifyingMessage } from "../general";

export class RemoveUserGroupsRequest extends ReplyVerifyingMessage {
    	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_REMOVE_USER_GROUPS;
	public static tag : MessageTag = MessageTag.REQ_REMOVE_USER_GROUPS;

  /**
   * Construct a new {@link RemoveUserGroupsRequest}.
   */
  constructor (
    public groups: number[],
    public objectId: number
  )
  {
    super();
  }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/remove-user-group-request.ts